import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { checkSeatsAndSteeringWheelBadges_etron, addListeners_etron, checkLocks_etron, getImages_etron } from './screen-package-selection-etron'
import { addListeners_etron_s, checkLocks_etron_s, getImages_etron_s } from './screen-package-selection-etron-s'
import { addListeners_etron_2025, checkLocks_etron_2025, getImages_etron_2025 } from './screen-package-selection-etron-2025'
import { checkSeatsAndSteeringWheelBadges_a6limousine, addListeners_a6limousine, checkLocks_a6limousine, getImages_a6limousine } from './screen-package-selection-a6limousine'
import { checkSeatsAndSteeringWheelBadges_RS6RS7, addListeners_RS6RS7, checkLocks_RS6RS7, getImages_RS6RS7 } from './screen-package-selection-RS6RS7'
import { checkSeatsAndSteeringWheelBadges_q7, addListeners_q7, checkLocks_q7, getImages_q7 } from './screen-package-selection-q7'
import { checkSeatsAndSteeringWheelBadges_q8, addListeners_q8, checkLocks_q8, getImages_q8 } from './screen-package-selection-q8'
import { checkSeatsAndSteeringWheelBadges_rsq8, addListeners_rsq8, checkLocks_rsq8, getImages_rsq8 } from './screen-package-selection-rsq8'
import { checkSeatsAndSteeringWheelBadges_a8, addListeners_a8, checkLocks_a8, getImages_a8 } from './screen-package-selection-a8'
import { checkSeatsAndSteeringWheelBadges_q6etron, addListeners_q6etron, checkLocks_q6etron, getImages_q6etron } from './screen-package-selection-q6etron'
import { checkSeatsAndSteeringWheelBadges_q6etron_s_line, addListeners_q6etron_s_line, checkLocks_q6etron_s_line, getImages_q6etron_s_line } from './screen-package-selection-q6etron_s_line'

import { checkSeatsAndSteeringWheelBadges_a5, addListeners_a5, checkLocks_a5, getImages_a5 } from './screen-package-selection-a5'
import { checkSeatsAndSteeringWheelBadges_a5_s_line, addListeners_a5_s_line, checkLocks_a5_s_line, getImages_a5_s_line } from './screen-package-selection-a5_s_line'
import { /*checkSeatsAndSteeringWheelBadges_rs5, */addListeners_rs5, /*checkLocks_rs5,*/ getImages_rs5 } from './screen-package-selection-rs5'
import { addListeners_sq6etron_perf, getImages_sq6etron_perf } from './screen-package-selection-sq6etron-perf'
import { addListeners_q7q9, getImages_q7q9 } from './screen-package-selection-q7q9'

import { checkSeatsAndSteeringWheelBadges_a6_etron, addListeners_a6_etron, checkLocks_a6_etron, getImages_a6_etron } from './screen-package-selection-a6_etron'
import { checkSeatsAndSteeringWheelBadges_a6_etron_s_line, addListeners_a6_etron_s_line, checkLocks_a6_etron_s_line, getImages_a6_etron_s_line } from './screen-package-selection-a6_etron_s_line'

import { checkSeatsAndSteeringWheelBadges_a6_c9, addListeners_a6_c9, checkLocks_a6_c9, getImages_a6_c9 } from './screen-package-selection-a6_c9'
import { checkSeatsAndSteeringWheelBadges_a6_c9_s_line, addListeners_a6_c9_s_line, checkLocks_a6_c9_s_line, getImages_a6_c9_s_line } from './screen-package-selection-a6_c9_s_line'

/* Q7/Q9 2026 Seater-Popup */
import { initQ7CarSelectSeatModal } from './screen-car-select-q7-seat-modal'
initQ7CarSelectSeatModal()
/* Q7/Q9 2026 Seater-Popup */

function saveStateWithAjax(code, status) {
	//console.log('saveStateWithAjax', code, status) 
	doAjax({
		'package_selection_option': code,
		'checked': status,
	}, (response) => {	
		document.querySelector('.aui-pager__max').innerHTML = response.maxpages;
		//console.log('saveStateWithAjax', response)
	})
}

function initCheckBoxesLogic() {

	// disable all input checkbox when audicode checked
	if (document.querySelector("input[name='check-audicode']").value == 1) {
		let checkboxes = document.querySelectorAll('.aui-checkbox__input');
		checkboxes.forEach(function (checkbox) {
			checkbox.addEventListener('click', function (event) {
				event.preventDefault();
				return false;
			});
		});
	}
	
	if (document.querySelector("input[name='is-car-rs-model']").value == 1) {
		//alert("get e-tron functions");
	}
	
	loadBlackUpperInterior()

	const frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
	const modalCheckboxes = document.querySelectorAll('.modal-checkboxes .aui-checkbox__input')
	var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)
	var modalsCheckboxesMap = getCodeAndCheckBoxMap(modalCheckboxes)

	if ((document.querySelector("input[name='carmodel']").value == 2 ) || (document.querySelector("input[name='carmodel']").value == 200 )) {	
		checkSeatsAndSteeringWheelBadges_etron()
		addListeners_etron(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_etron(frontCheckboxesMap)	
		getImages_etron(frontCheckboxesMap)
	}
	if (document.querySelector("input[name='carmodel']").value == 1 ) {	
		addListeners_etron_s(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_etron_s(frontCheckboxesMap)	
		getImages_etron_s(frontCheckboxesMap)
	}

	if (document.querySelector("input[name='carmodel']").value == 201 ) {	
		addListeners_etron_2025(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_etron_2025(frontCheckboxesMap)	
		getImages_etron_2025(frontCheckboxesMap)
	}
	/* A6/A7 */
	if (
		(document.querySelector("input[name='carmodel']").value == 3) ||
		(document.querySelector("input[name='carmodel']").value == 4) || 
		(document.querySelector("input[name='carmodel']").value == 5) || 
		(document.querySelector("input[name='carmodel']").value == 6) || 
		(document.querySelector("input[name='carmodel']").value == 7) || 
		(document.querySelector("input[name='carmodel']").value == 8) || 
		(document.querySelector("input[name='carmodel']").value == 9) || 
		(document.querySelector("input[name='carmodel']").value == 11) || 
		(document.querySelector("input[name='carmodel']").value == 12) || 
		(document.querySelector("input[name='carmodel']").value == 13)) {	
		checkSeatsAndSteeringWheelBadges_a6limousine()
		addListeners_a6limousine(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_a6limousine(frontCheckboxesMap)	
		getImages_a6limousine(frontCheckboxesMap)
	}
	if ((document.querySelector("input[name='carmodel']").value == 10) || (document.querySelector("input[name='carmodel']").value == 14)) {	
		checkSeatsAndSteeringWheelBadges_RS6RS7()
		addListeners_RS6RS7(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_RS6RS7(frontCheckboxesMap)	
		getImages_RS6RS7(frontCheckboxesMap)
	}
	/* Q7/Q8 */
	if (
		(document.querySelector("input[name='carmodel']").value == 15) || 
		(document.querySelector("input[name='carmodel']").value == 16) || 
		(document.querySelector("input[name='carmodel']").value == 17)) {	
		checkSeatsAndSteeringWheelBadges_q7()
		addListeners_q7(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_q7(frontCheckboxesMap)	
		getImages_q7(frontCheckboxesMap)
	}
	if (
		(document.querySelector("input[name='carmodel']").value == 18) || 
		(document.querySelector("input[name='carmodel']").value == 19) || 
		(document.querySelector("input[name='carmodel']").value == 20)) {	
		checkSeatsAndSteeringWheelBadges_q8()
		addListeners_q8(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_q8(frontCheckboxesMap)	
		getImages_q8(frontCheckboxesMap)
	}
	if ((document.querySelector("input[name='carmodel']").value == 21)){	
		checkSeatsAndSteeringWheelBadges_rsq8()
		addListeners_rsq8(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_rsq8(frontCheckboxesMap)	
		getImages_rsq8(frontCheckboxesMap)
	}

	/* Q7/Q9 2026 */	
	if (
		(document.querySelector("input[name='carmodel']").value == 115) || 
		(document.querySelector("input[name='carmodel']").value == 116) || 
		(document.querySelector("input[name='carmodel']").value == 117) || 
		(document.querySelector("input[name='carmodel']").value == 118) || 
		(document.querySelector("input[name='carmodel']").value == 119) || 
		(document.querySelector("input[name='carmodel']").value == 120)) {
		addListeners_q7q9(frontCheckboxesMap, modalsCheckboxesMap)
		getImages_q7q9(frontCheckboxesMap)
	}

	/* A8 */
	if (
		(document.querySelector("input[name='carmodel']").value == 22) || 
		(document.querySelector("input[name='carmodel']").value == 23) || 
		(document.querySelector("input[name='carmodel']").value == 24) || 
		(document.querySelector("input[name='carmodel']").value == 25) || 
		(document.querySelector("input[name='carmodel']").value == 26) || 
		(document.querySelector("input[name='carmodel']").value == 27)) {	
		checkSeatsAndSteeringWheelBadges_a8()
		addListeners_a8(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_a8(frontCheckboxesMap)	
		getImages_a8(frontCheckboxesMap)
	}
	
	checkSubmit(frontCheckboxesMap)
	
	// etron Q6	
	if (
		(document.querySelector("input[name='carmodel']").value == 34) || 
		(document.querySelector("input[name='carmodel']").value == 37)) {	
		checkSeatsAndSteeringWheelBadges_q6etron()
		addListeners_q6etron(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_q6etron(frontCheckboxesMap)	
		getImages_q6etron(frontCheckboxesMap)
	}
	if (
		(document.querySelector("input[name='carmodel']").value == 35) || 
		(document.querySelector("input[name='carmodel']").value == 36) || 
		(document.querySelector("input[name='carmodel']").value == 38) || 
		(document.querySelector("input[name='carmodel']").value == 39)) {	
		checkSeatsAndSteeringWheelBadges_q6etron_s_line()
		addListeners_q6etron_s_line(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_q6etron_s_line(frontCheckboxesMap)	
		getImages_q6etron_s_line(frontCheckboxesMap)
	}
	if (
		(document.querySelector("input[name='carmodel']").value == 70) ||
		(document.querySelector("input[name='carmodel']").value == 71)) {
		addListeners_sq6etron_perf(frontCheckboxesMap, modalsCheckboxesMap)
		getImages_sq6etron_perf(frontCheckboxesMap)
	}

	// A5
	if (
		(document.querySelector("input[name='carmodel']").value == 40) || 
		(document.querySelector("input[name='carmodel']").value == 42)) {	
		checkSeatsAndSteeringWheelBadges_a5()
		addListeners_a5(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_a5(frontCheckboxesMap)	
		getImages_a5(frontCheckboxesMap)
	}
	if (
		(document.querySelector("input[name='carmodel']").value == 41) || 
		(document.querySelector("input[name='carmodel']").value == 43) || 
		(document.querySelector("input[name='carmodel']").value == 44) || 
		(document.querySelector("input[name='carmodel']").value == 45)) {	
		checkSeatsAndSteeringWheelBadges_a5_s_line()
		addListeners_a5_s_line(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_a5_s_line(frontCheckboxesMap)	
		getImages_a5_s_line(frontCheckboxesMap)
	}
	if (
		(document.querySelector("input[name='carmodel']").value == 46) || 
		(document.querySelector("input[name='carmodel']").value == 47)) {	
		//checkSeatsAndSteeringWheelBadges_rs5()
		addListeners_rs5(frontCheckboxesMap, modalsCheckboxesMap)
		//checkLocks_rs5(frontCheckboxesMap)	
		getImages_rs5(frontCheckboxesMap)
	}

	// A6 e-tron
	if (
		(document.querySelector("input[name='carmodel']").value == 50) || 
		(document.querySelector("input[name='carmodel']").value == 52)) {	
		checkSeatsAndSteeringWheelBadges_a6_etron()
		addListeners_a6_etron(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_a6_etron(frontCheckboxesMap)	
		getImages_a6_etron(frontCheckboxesMap)
	}
	if (
		(document.querySelector("input[name='carmodel']").value == 51) || 
		(document.querySelector("input[name='carmodel']").value == 53) || 
		(document.querySelector("input[name='carmodel']").value == 54) || 
		(document.querySelector("input[name='carmodel']").value == 55)) {	
		checkSeatsAndSteeringWheelBadges_a6_etron_s_line()
		addListeners_a6_etron_s_line(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_a6_etron_s_line(frontCheckboxesMap)	
		getImages_a6_etron_s_line(frontCheckboxesMap)
	}

	// A6 (C9))
	if (
		(document.querySelector("input[name='carmodel']").value == 60) || 
		(document.querySelector("input[name='carmodel']").value == 62)) {	
		checkSeatsAndSteeringWheelBadges_a6_c9()
		addListeners_a6_c9(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_a6_c9(frontCheckboxesMap)	
		getImages_a6_c9(frontCheckboxesMap)
		checkAndShowLabelsQ8H_7HH_7HF();
	}
	if (
		(document.querySelector("input[name='carmodel']").value == 61) || 
		(document.querySelector("input[name='carmodel']").value == 63) || 
		(document.querySelector("input[name='carmodel']").value == 64) || 
		(document.querySelector("input[name='carmodel']").value == 65)) {	
		checkSeatsAndSteeringWheelBadges_a6_c9_s_line()
		addListeners_a6_c9_s_line(frontCheckboxesMap, modalsCheckboxesMap)
		checkLocks_a6_c9_s_line(frontCheckboxesMap)	
		getImages_a6_c9_s_line(frontCheckboxesMap)
		checkAndShowLabelsQ8H_7HH_7HF();
	}
}


function checkKey(map, code) {
	var foundKey = false
	for (var key in map) {
		if (key == code) foundKey = true;
	}
	return foundKey;
}

function getCodeAndCheckBoxMap(checkboxes) {
	var checkboxesMap = new Map()
	try {
		checkboxes.forEach(element => {
			checkboxesMap[element.parentElement.getAttribute('data-auicode').toString()] = element
		})
	} catch (exception) {
		console.error(exception)
	}
	return checkboxesMap
}

function checkCheckedOptions(frontCheckboxesMap){
	for (const property in frontCheckboxesMap) {
		if(frontCheckboxesMap[property].checked){
			return true
		}
	}
	return false
}

function checkSubmit(frontCheckboxesMap) {
	const submitButton = document.getElementById('navigation-submit-btn')
	if (submitButton==null) return
	submitButton.disabled = !checkCheckedOptions(frontCheckboxesMap)
}


function getPackageImageSource(packageCode) {
	var CarmodelWheel = document.querySelector("input[name='carmodel']").value
	if ((CarmodelWheel == 2) || (CarmodelWheel == 200)) {
		if (packageCode == 'YVE') packageCode = 'YVE_RS';
	}	
	
	if ((CarmodelWheel == 4) || (CarmodelWheel == 6) || (CarmodelWheel == 8) || (CarmodelWheel == 9) || (CarmodelWheel == 10) || (CarmodelWheel == 12) || (CarmodelWheel == 13) || (CarmodelWheel == 14)) {
		if (packageCode == 'YVU'){	
			packageCode = 'YVU_sport'
		}
		/*
		if (packageCode == 'YSI'){	
			packageCode = 'YSI_sport'
		}
		*/
		if (packageCode == 'YSJ_A6'){	
			packageCode = 'YSJ_sport'
		}
	}

	if ((CarmodelWheel == 16) || (CarmodelWheel == 17) || (CarmodelWheel == 19) || (CarmodelWheel == 20)) {
		if (packageCode == 'YZ1_Q7Q8') packageCode = 'YZ1_Q7Q8_S_line';
		//if (packageCode == 'YSI_Q7Q8') packageCode = 'YSI_Q7Q8_S_line';
		if (packageCode == 'YSN') packageCode = 'YSN_S_line';
		if (packageCode == 'YSJ_Q7Q8') packageCode = 'YSJ_Q7Q8_S_line';
		//if (packageCode == 'YVK') packageCode = 'YVK_S_line';
		//if (packageCode == 'YXP') packageCode = 'YXP_S_line';
		if (packageCode == 'YVU_Q7Q8') packageCode = 'YVU_Q7Q8_S_line';
		if (packageCode == 'YTA_Q7Q8') packageCode = 'YTA_Q7Q8_S_line';
		if (packageCode == 'YTO_Q7Q8') packageCode = 'YTO_Q7Q8_S_line';
		if (packageCode == 'YTQ_Q7Q8') packageCode = 'YTQ_Q7Q8_S_line';
		if (packageCode == 'YSQ_Q7Q8') packageCode = 'YSQ_Q7Q8_S_line';
	}

	if ((CarmodelWheel == 23) || (CarmodelWheel == 25) || (CarmodelWheel == 26) || (CarmodelWheel == 27)) {
		if (packageCode == 'YZ1_A8') packageCode = 'YZ1_A8_S_line';
		if (packageCode == 'YZ4_A8') packageCode = 'YZ4_A8_S_line';
		if (packageCode == 'YVU_A8') packageCode = 'YVU_A8_S_line';
		if (packageCode == 'YTA_A8') packageCode = 'YTA_A8_S_line';
		if (packageCode == 'YTO_A8') packageCode = 'YTO_A8_S_line';
		if (packageCode == 'YSR_A8') packageCode = 'YSR_A8_S_line';
	}

	if ((CarmodelWheel == 35) || (CarmodelWheel == 36) || (CarmodelWheel == 38) || (CarmodelWheel == 39)) {
		if (packageCode == 'Q8H') packageCode = 'Q8H_S_line';
		if (packageCode == '0UD') packageCode = '0UD_S_line';
		if (packageCode == 'FZ9') packageCode = 'FZ9_S_line';
		if (packageCode == '0TF') packageCode = '0TF_S_line';
	}

	if ((CarmodelWheel == 70) || (CarmodelWheel == 71)) {
		if (packageCode == 'FC1') packageCode = 'FC1_SQ6_perf';
		if (packageCode == 'Q8H') packageCode = 'Q8H_SQ6_perf';
		if (packageCode == 'FZ9') packageCode = 'FZ9_SQ6_perf';
		if (packageCode == '0TF') packageCode = '0TF_SQ6_perf';
		if (packageCode == 'YFA_Q6etron') packageCode = 'YFA_SQ6_perf';
		if (packageCode == 'YFB_Q6etron') packageCode = 'YFB_SQ6_perf';
	}

	if ((CarmodelWheel == 41) || (CarmodelWheel == 43) || (CarmodelWheel == 44) || (CarmodelWheel == 45)) {
		if (packageCode == 'Q8H_A5') packageCode = 'Q8H_A5_S_line';
		if (packageCode == '0UD_A5') packageCode = '0UD_A5_S_line';
		if (packageCode == 'FZ8_A5') packageCode = 'FZ8_A5_S_line';
		if (packageCode == 'FZ9_A5') packageCode = 'FZ9_A5_S_line';
		if (packageCode == '0TF_A5') packageCode = '0TF_A5_S_line';
	}

	if ((CarmodelWheel == 46) || (CarmodelWheel == 47)) {
		if (packageCode == 'Q8H_A5') packageCode = 'Q8H_A5_RS';
		//if (packageCode == '0UD_A5') packageCode = '0UD_A5_RS';
		if (packageCode == 'FZ8_A5') packageCode = 'FZ8_A5_RS';
		if (packageCode == 'FZ9_A5') packageCode = 'FZ9_A5_RS';
		if (packageCode == '0TF_A5') packageCode = '0TF_A5_RS';
		if (packageCode == '7TZ_A5') packageCode = '7TZ_A5_RS';
		if (packageCode == 'FC1_A5') packageCode = 'FC1_A5_RS';
		if (packageCode == 'YFA_A5') packageCode = 'YFA_A5_RS';
		if (packageCode == 'YFB_A5') packageCode = 'YFB_A5_RS';
		if (packageCode == 'YN3_A5') packageCode = 'YN3_A5_RS';
		if (packageCode == 'YN4_A5') packageCode = 'YN4_A5_RS';
	}

	if ((CarmodelWheel == 51) || (CarmodelWheel == 53) || (CarmodelWheel == 54) || (CarmodelWheel == 55)) {
		if (packageCode == 'Q8H_A6etron') packageCode = 'Q8H_A6etron_S_line';
		if (packageCode == '0UD_A6etron') packageCode = '0UD_A6etron_S_line';
		if (packageCode == 'FZ9_A6etron') packageCode = 'FZ9_A6etron_S_line';
		if (packageCode == 'FZ8_A6etron') packageCode = 'FZ8_A6etron_S_line';
		if (packageCode == '0TF_A6etron') packageCode = '0TF_A6etron_S_line';
	}

	if ((CarmodelWheel == 61) || (CarmodelWheel == 63) || (CarmodelWheel == 64) || (CarmodelWheel == 65)) {
		if (packageCode == 'Q8H_A6_C9') packageCode = 'Q8H_A6_C9_S_line';
		if (packageCode == '0UD_A6_C9') packageCode = '0UD_A6_C9_S_line';
		if (packageCode == 'FZ9_A6_C9') packageCode = 'FZ9_A6_C9_S_line';
		if (packageCode == '0TF_A6_C9') packageCode = '0TF_A6_C9_S_line';
	}

	if ((CarmodelWheel == 22) || (CarmodelWheel == 24)) { 
		// Change YTA when YZ4 selected - only for A8 and A8 L	
		if ($( "label[data-auicode='YZ4_A8'] input" ).is(":checked") && $( "label[data-auicode='YTA_A8'] input" ).is(":checked"))
			{
				if (packageCode == 'YTA_A8') packageCode = 'YTA_A8_S_line';
			}	
		// Change YTA when YZ4 selected - only for A8 and A8 L	
	}


	if ((CarmodelWheel == 116) || (CarmodelWheel == 117) || (CarmodelWheel == 119) || (CarmodelWheel == 120)) { 
		if (packageCode == '0UB_Q7Q9') packageCode = '0UB_Q7Q9_S_line';
		if (packageCode == 'YN1_Q7Q9') packageCode = 'YN1_Q7Q9_S_line';
		if (packageCode == 'YN2_Q7Q9') packageCode = 'YN2_Q7Q9_S_line';
		if (packageCode == 'YFA_Q7Q9') packageCode = 'YFA_Q7Q9_S_line';
		if (packageCode == 'YFB_Q7Q9') packageCode = 'YFB_Q7Q9_S_line';

		if (packageCode == '97R_Q7Q9') packageCode = '97R_Q7Q9_S_line';

		if (packageCode == '7HH_Q7Q9') packageCode = '7HH_Q7Q9_S_line';
		if (packageCode == '7HF_Q7Q9') packageCode = '7HF_Q7Q9_S_line';
		if (packageCode == '7HM_Q7Q9') packageCode = '7HM_Q7Q9_S_line';

		if (packageCode == 'FZ8_Q7Q9') packageCode = 'FZ8_Q7Q9_S_line';
		if (packageCode == 'FZ9_Q7Q9') packageCode = 'FZ9_Q7Q9_S_line';

		if (packageCode == '0TF_Q7Q9') packageCode = '0TF_Q7Q9_S_line';

		if (packageCode == 'PWB_JV') packageCode = 'PWB_JV_S_line';
		if (packageCode == 'PWD_QM') packageCode = 'PWD_QM_S_line';
		if (packageCode == 'PWD_QX') packageCode = 'PWD_QX_S_line';
	}

	return aeo['images']['package_cover'][packageCode]
}

function loadBlackUpperInterior() {
	const interiorUpperVars = ['upperDashboardColor', 'stitchUpperDashboardColor', 'instrumentPanelCoverColor',
		'stitchInstrumentPanelCoverColor', 'doorRailColor', 'stitchDoorRailColor'];
	interiorUpperVars.forEach(component => {
		//replace image on interior
		let images = getInteriorImageForStoredComponent('car_interior', component, "8") // 8 always black
		for (const jsonkey in images) {
			if (Object.hasOwnProperty.call(images, jsonkey)) {
				const imgSrc = images[jsonkey];
				if (imgSrc != "" && jsonkey == "front_interior_image") {
					replaceImage(imgSrc, component)
				}
			}
		}
		
	});					
}

function replaceImage(imageSource, component) {
	let query = "#front-seats img.overlay"
	let imageArray = document.querySelectorAll(query);


	if (imageArray.length == 0) return;

	//if image exists, modify src
	const imageId = component + '-img'
	let imageExists = false;
	imageArray.forEach(element => {
		if (element.id != null && element.id == imageId) {
			imageExists = true
			element.src = imageSource
		}
	});
	//if image does not exist, create it
	if (!imageExists) {
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.id = component + '-img'
		imageArray[imageArray.length - 1].insertAdjacentElement('afterend', newImage)
		newImage.src = imageSource
	}

}

// Funktion zur Prüfung und Anzeige der Labels
function checkAndShowLabelsQ8H_7HH_7HF() {
	const q8hLabel = jQuery('label[data-auicode="Q8H_A6_C9"]');
	const hfLabel = jQuery('label[data-auicode="7HF_A6_C9"]');

	const isQ8HChecked = q8hLabel.hasClass('is-checked');
	const isHFChecked = hfLabel.hasClass('is-checked');

	// Beide Labels zunächst verstecken
	q8hLabel.hide();
	hfLabel.hide();

	if (isQ8HChecked) {
		q8hLabel.show();
	} else if (isHFChecked) {
		hfLabel.show();
	} else {
		// Wenn keines checked ist, Q8H_A6_C9 anzeigen
		q8hLabel.show();
	}
}

export { initCheckBoxesLogic, saveStateWithAjax, checkKey, checkSubmit, getPackageImageSource, getCodeAndCheckBoxMap}
